import { useReducer } from 'react';
import {
  doc, setDoc, addDoc, collection,
} from 'firebase/firestore';
import { firestore } from '../utils/firebase';

const initState = {
  document: null,
  isPending: false,
  error: null,
  success: null,
};

const firestoreReducer = (state, action) => {
  switch (action.type) {
    case 'is_pending':
      return {
        isPending: true, success: false, error: null, document: null,
      };
    case 'set_document':
      return {
        isPending: false, document: action.payload, success: true, error: null,
      };
    case 'error':
      return {
        isPending: false, document: null, success: false, error: action.payload,
      };
    default:
      return state;
  }
};

const useFirestore = () => {
  const [response, dispatch] = useReducer(firestoreReducer, initState);

  const setUser = async (userId, data) => {
    dispatch({ type: 'is_pending' });

    try {
      const ref = doc(firestore, 'users', userId);
      const docRef = await setDoc(ref, data);
      dispatch({ type: 'set_document', payload: docRef });
    } catch (err) {
      dispatch({ type: 'error', payload: err.message });
    }
  };

  const setSessionData = async (userID, data) => {
    dispatch({ type: 'is_pending' });
    try {
      const ref = collection(firestore, `tracking/${userID}/sessions`);
      const docRef = await addDoc(ref, data);
      dispatch({ type: 'set_document', payload: docRef });
    } catch (err) {
      dispatch({ type: 'error', payload: err.message });
    }
  };

  return { setUser, setSessionData, response };
};

export default useFirestore;
